export const stageKey = ({name, id}) => `${name}.${window._env_.I18_SEED}${id}`;

export const museumTranslationKey = ({type, id}) => `${type}${id}`;

export const museumNs = museumId => `${window._env_.I18_SEED}-${museumId}`;